import React from 'react'
import styled from 'styled-components'
const TodayLine = styled.line`
  stroke: #555;
  stroke-dasharray: 10;
  stroke-width: 1.5;
`

const TodayText = styled.text`
  alignment-baseline: hanging;
  text-anchor: end;
  fill: #555;
`

const Today = ({
  today = new Date(),
  minDate,
  maxDate,
  xScale,
  yScale,
  minValue,
  maxValue,
}) =>
  today.getTime() < maxDate.getTime() &&
  today.getTime() > minDate.getTime() && [
    <TodayLine
      key="line"
      x1={xScale(today)}
      y1={yScale(minValue)}
      x2={xScale(today)}
      y2={yScale(maxValue)}
    />,
    <TodayText
      key="text"
      x={xScale(today) + 8}
      y={15}
      transform={`rotate(270 ${xScale(today) + 8} 15)`}
    >
      Today
    </TodayText>,
  ]

export default Today
